<template>
  <div class="env-watermark" :style="{ backgroundImage: bgImage }" aria-hidden="true"></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: { type: String, required: true },
  color: { type: String, default: '#000' },
});

// SVG 作为 background-repeat tile，无论屏幕多大都能均匀铺满
const bgImage = computed(() => {
  const svgTile = '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="130">'
    + `<text transform="rotate(-25 100 65)" x="100" y="78" font-size="13" fill="${props.color}"`
    + ' font-family="sans-serif" letter-spacing="2" text-anchor="middle">' + props.text + '</text>'
    + '</svg>';
  return `url("data:image/svg+xml,${encodeURIComponent(svgTile)}")`;
});
</script>

<style scoped>
.env-watermark {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  opacity: 0.12;
  background-repeat: repeat;
  background-size: 200px 130px;
}
</style>
